import axios from 'axios';

const API_URL = 'https://mokalive.net:8000/api';

const api = axios.create({
  baseURL: API_URL,
});

export const preRegister = async (email: string, name: string, password: string, re_password: string) => {
  return await api.post('/auth/users/', { email, name, password, re_password });
};

export const preRegisterCode = async (email: string, code: string) => {
  return await api.post('/user/update-code/', { email, code });
};

export const checkActivation = async (code: string) => {
  return await api.post('/check-activation-code/', { code });
};

export const completeRegister = async (uid: string, token: string) => {
  return await api.post('/auth/users/activation/', { uid, token });
};

export const login = async (email: string, password: string) => {
  return await api.post('/auth/jwt/create/', { email, password });
};

export const refreshAccessToken = async (refresh: string) => {
  return await api.post('/auth/jwt/refresh/', { refresh });
};

export const getProtectedResource = async (token: string) => {
  return await api.get('/auth/users/me/', {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const updateProtectedResource = async (name: string, token: string) => {
  return await api.patch('/user/update/name/', {
    name,
  }, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
}

export const updateActivationCode = async (code: string, token: string) => {
  return await api.patch('/user/update/name/', {
    code,
  }, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
}

export const getProtectedResourceDetail = async (token: string) => {
  return await api.get('/user/update/', {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const getUserDetails = async (email: string, token: string) => {
  return await api.get(`/user/details/${email}/`, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
}

export const updateUserPoints = async (email: string, points: number, token: string) => {
  return await api.post('/user/update-points/', {
    email,
    points
  }, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const incrementUserParticipation = async (email: string, token: string) => {
  return await api.post('/user/increment-user-participation/', {
    email,
  }, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const UpsdatePassWord = async (new_password: string, re_new_password: string, current_password: string, token: string) => {
  return await api.post('/auth/users/set_password/', {
    current_password,
    new_password,
    re_new_password,
  }, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const RequestUpdateEmail = async (email: string, token: string) => {
  return await api.post('/auth/users/reset_email/', {
    email,
  }, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const UpdateEmail = async (new_email: string, re_new_email: string, uid: string, token: string, j_token: string) => {
  return await api.post('/auth/users/reset_email_confirm/', {
    uid,
    token,
    new_email,
    re_new_email,
  }, {
    headers: {
      Authorization: `JWT ${j_token}`
    }
  });
};

export const RequestResetPassword = async (email: string) => {
  return await api.post('/auth/users/reset_password/', {
    email,
  },
  );
};

export const ResetPassword = async (new_password: string, re_new_password: string, uid: string, token: string,) => {
  return await api.post('/auth/users/reset_password_confirm/', {
    uid,
    token,
    new_password,
    re_new_password,
  }, {
  });
};

export const distributeCoupons = async (token: string) => {
  return await api.post('/user/coupons/distribute/', {}, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export const updateCoupon = async (token: string, userCouponId: number) => {
  console.log(userCouponId)
  return await api.post('/use_coupon/', {
    user_coupon_id: userCouponId,
  }, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

export const createAnnouncement = async (token: string, title: string, message: string, sendEmail: boolean = false) => {
  return await api.post(
    '/announcements/',  // エンドポイントは適宜変更してください
    {
      title,
      message,
      send_email: sendEmail,  // メール送信フラグ
    },
    {
      headers: {
        Authorization: `JWT ${token}`,  // 認証ヘッダーにトークンを追加
        'Content-Type': 'application/json',
      },
    }
  );
};

// Fetch the announcement list
export const getAnnouncements = async (token: string) => {
  return await api.get('/announcements/list/', {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

export const getLastIncrementDate = async (token: string) => {
  return await api.get('/user/last-increment-date/', {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// export const getUser = async (token: string, code?: string, points?: number, times?: number) => {
//   return await api.get('/user/update/', {
//     headers: {
//       Authorization: `JWT ${token}`
//     },
//     data: {
//       code, points, times
//     }
//   });
// };

export const createHint = async (
  token: string,
  text: string,
  image: File | null,
  latitude: number | null,
  longitude: number | null
) => {
  const formData = new FormData();
  formData.append("text", text);
  if (image) {
    formData.append("image", image);
  }
  if (latitude !== null && longitude !== null) {
    formData.append("latitude", latitude.toString());
    formData.append("longitude", longitude.toString());
  }

  return await api.post('/hints/', formData, {
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getHints = async (token: string) => {
  return await api.get('/hints/list/', {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// コメント関連のAPI
export const getComments = async (token: string) => {
  return await api.get('/comments/', {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// ヒントごとのコメント一覧取得
export const getCommentsByHint = async (token: string, hintId: number) => {
  return await api.get(`/comments/?hint_id=${hintId}`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// ヒントへのコメント投稿
export const postCommentToHint = async (token: string, hintId: number, text: string) => {
  return await api.post('/comments/', { hint: hintId, text }, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// ヒント削除API
export const deleteHint = async (token: string, hintId: number) => {
  return await api.delete(`/hints/${hintId}/`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// コメント削除API
export const deleteComment = async (token: string, commentId: number) => {
  return await api.delete(`/comments/${commentId}/`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

// Push通知関連のAPI

/**
 * VAPID公開鍵を取得
 */
export const getVAPIDPublicKey = async () => {
  try {
    const response = await api.get('/vapid-public-key/');
    return response.data.public_key;
  } catch (error) {
    console.error('VAPID公開鍵の取得に失敗:', error);
    throw error;
  }
};

/**
 * Push通知を購読
 */
export const subscribeToPush = async (token: string, subscriptionData: {
  endpoint: string;
  auth: string;
  p256dh: string;
}) => {
  return await api.post('/push-subscription/', subscriptionData, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });
};

/**
 * Push通知の購読を解除
 */
export const unsubscribeFromPush = async (token: string, endpoint: string) => {
  return await api.delete('/push-subscription/', {
    headers: {
      Authorization: `JWT ${token}`,
    },
    data: {
      endpoint: endpoint
    }
  });
};

// Push通知のユーティリティ関数

/**
 * Base64エンコードされたVAPID公開鍵をUint8Arrayに変換
 */
function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * サービスワーカーを登録
 */
export const registerServiceWorker = async () => {
    if ('serviceWorker' in navigator) {
        try {
            const registration = await navigator.serviceWorker.register('/sw.js');
            console.log('Service Worker registered:', registration);
            return registration;
        } catch (error) {
            console.error('Service Worker registration failed:', error);
            throw error;
        }
    } else {
        throw new Error('Service Worker is not supported');
    }
};

/**
 * Push通知の許可を要求
 */
export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
        throw new Error('This browser does not support notifications');
    }

    const permission = await Notification.requestPermission();
    return permission === 'granted';
};

/**
 * Push通知を購読
 */
export const subscribeToPushNotification = async (token: string) => {
    try {
        // サービスワーカーの登録
        const registration = await registerServiceWorker();
        
        // 通知の許可を要求
        const hasPermission = await requestNotificationPermission();
        if (!hasPermission) {
            throw new Error('Notification permission denied');
        }

        // VAPID公開鍵を取得
        const publicKey = await getVAPIDPublicKey();
        
        // Push通知を購読
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey)
        });

        // キーを安全に取得
        const authKey = subscription.getKey('auth');
        const p256dhKey = subscription.getKey('p256dh');
        
        if (!authKey || !p256dhKey) {
            throw new Error('Failed to get subscription keys');
        }

        // サーバーに購読情報を送信
        const subscriptionData = {
            endpoint: subscription.endpoint,
            auth: btoa(String.fromCharCode(...Array.from(new Uint8Array(authKey)))),
            p256dh: btoa(String.fromCharCode(...Array.from(new Uint8Array(p256dhKey))))
        };

        await subscribeToPush(token, subscriptionData);

        console.log('Push通知の購読が完了しました');
        return subscription;
    } catch (error) {
        console.error('Push通知の購読に失敗:', error);
        throw error;
    }
};

/**
 * Push通知の購読を解除
 */
export const unsubscribeFromPushNotification = async (token: string) => {
    try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        
        if (subscription) {
            // サーバーから購読情報を削除（404エラーは無視）
            try {
                await unsubscribeFromPush(token, subscription.endpoint);
            } catch (error: any) {
                // 404エラーの場合は既に削除されているものとして処理を続行
                if (error.response?.status !== 404) {
                    throw error;
                }
                console.log('サーバー側の購読情報は既に削除されています');
            }

            // ブラウザから購読を解除
            await subscription.unsubscribe();
            console.log('Push通知の購読を解除しました');
        } else {
            console.log('購読情報が見つかりませんでした');
        }
    } catch (error) {
        console.error('Push通知の購読解除に失敗:', error);
        throw error;
    }
};

/**
 * Push通知の購読状態を確認（ブラウザとサーバーの状態を同期）
 */
export const checkPushSubscription = async (token?: string) => {
    try {
        console.log('checkPushSubscription called with token:', token ? 'Present' : 'None');
        
        // サービスワーカーがサポートされていない場合
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            console.log('Service Worker or Push Manager not supported');
            return false;
        }

        const registration = await navigator.serviceWorker.ready;
        const browserSubscription = await registration.pushManager.getSubscription();
        
        console.log('Browser subscription:', browserSubscription ? 'Present' : 'None');
        
        // トークンがある場合はサーバー側の状態も確認
        if (token) {
            const serverSubscribed = await checkServerPushSubscription(token);
            console.log('Server subscription:', serverSubscribed);
            
            // サーバー側に購読があり、ブラウザ側にも購読がある場合は有効
            if (serverSubscribed && browserSubscription) {
                console.log('Both server and browser subscriptions exist');
                return true;
            }
            
            // サーバー側に購読があるが、ブラウザ側にない場合は有効（サーバー側の購読状態を優先）
            if (serverSubscribed && !browserSubscription) {
                console.log('Server subscription exists but browser subscription is missing');
                return true;
            }
            
            // サーバー側に購読がなく、ブラウザ側にある場合は、ブラウザ側をクリア
            if (!serverSubscribed && browserSubscription) {
                console.log('Browser subscription exists but server subscription is missing - clearing browser subscription');
                await browserSubscription.unsubscribe();
                return false;
            }
            
            // どちらも購読していない場合は無効
            return false;
        } else {
            // トークンがない場合はブラウザの状態のみを返す
            const result = browserSubscription !== null;
            console.log('Browser only subscription status:', result);
            return result;
        }
    } catch (error) {
        console.error('Push通知の購読状態確認に失敗:', error);
        return false;
    }
};

/**
 * サーバー側のPush通知購読状態を確認
 */
export const checkServerPushSubscription = async (token: string) => {
  try {
    console.log('Checking server push subscription with token:', token ? 'Present' : 'None');
    const response = await api.get('/push-subscription/', {
      headers: {
        Authorization: `JWT ${token}`,
      },
    });
    console.log('Server response:', response.data);
    return response.data.is_subscribed;
  } catch (error: any) {
    console.error('サーバー側の購読状態確認に失敗:', error);
    if (error.response) {
      console.error('Error response:', error.response.status, error.response.data);
    }
    return false;
  }
};

/**
 * テスト用Push通知を送信（個人のみ）
 */
export const sendTestPushNotification = async (token: string) => {
  try {
    console.log('Sending test push notification with token:', token ? 'Present' : 'None');
    const response = await api.post('/test-push-notification/', {}, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    });
    console.log('Test notification response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('テスト通知の送信に失敗:', error);
    if (error.response) {
      console.error('Error response:', error.response.status, error.response.data);
    }
    throw error;
  }
};

// ========== 新ポイントシステムAPI ==========

/**
 * ランクルール一覧取得
 */
export const getRankRules = async (token: string) => {
  return await api.get('/ranks/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ユーザーの現在ランク情報取得
 */
export const getUserRankInfo = async (token: string) => {
  return await api.get('/rank/info/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ランクバッジ画像取得
 */
export const getRankBadge = async (token: string) => {
  const cacheBuster = Date.now();
  return await api.get(`/rank/badge/?_t=${cacheBuster}`, {
    headers: {
      Authorization: `JWT ${token}`
    },
    responseType: 'blob'
  });
};

/**
 * 公開済みライブイベント一覧取得
 */
export const getLiveEvents = async (token: string) => {
  return await api.get('/live-events/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ライブイベント作成（スタッフ専用）
 */
export const createLiveEvent = async (token: string, data: any) => {
  return await api.post('/live-events/manage/', data, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ライブイベント更新（スタッフ専用）
 */
export const updateLiveEvent = async (token: string, id: number, data: any) => {
  return await api.put(`/live-events/manage/${id}/`, data, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ライブイベント削除（スタッフ専用）
 */
export const deleteLiveEvent = async (token: string, id: number) => {
  return await api.delete(`/live-events/manage/${id}/`, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * 全通判定取得
 */
export const getLiveEventCompletion = async (token: string) => {
  return await api.get('/live-events/completion/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ポイント履歴取得
 */
export const getPointTransactions = async (token: string, type?: string) => {
  const params = type ? { type } : {};
  return await api.get('/points/transactions/', {
    headers: { Authorization: `JWT ${token}` },
    params
  });
};

export const deletePointTransaction = async (token: string, id: number) => {
  return await api.delete(`/points/transactions/${id}/`, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * 購入ポイント付与（スタッフ専用）
 */
export const purchasePoints = async (
  token: string, 
  userId: number, 
  amount: number, 
  liveEventId?: number, 
  memo?: string
) => {
  return await api.post('/points/purchase/', {
    user_id: userId,
    amount,
    live_event_id: liveEventId,
    memo
  }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * 来店付与（スタッフ専用）
 */
export const visitPoints = async (token: string, userId: number, liveEventId: number) => {
  return await api.post('/points/visit/', {
    user_id: userId,
    live_event_id: liveEventId
  }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * 来店ログ取得
 */
export const getVisitLogs = async (token: string) => {
  return await api.get('/visits/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

export const deleteVisitLog = async (token: string, id: number) => {
  return await api.delete(`/visits/${id}/`, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * 交換申請一覧取得
 */
export const getRedemptions = async (token: string) => {
  return await api.get('/rewards/redemptions/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * ポイント交換申請
 */
export const redeemReward = async (token: string, rewardName: string, costPoints: number) => {
  return await api.post('/rewards/redeem/', {
    reward_name: rewardName,
    cost_points: costPoints
  }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

/**
 * もん王イベント用のAPI関数
 */

// 質問の投稿
export const postMonouQuestion = async (token: string, text: string) => {
  return await api.post('/monou/questions/', { text }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 自分の質問一覧取得
export const getMyMonouQuestions = async (token: string) => {
  return await api.get('/monou/questions/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 質問の更新
export const updateMonouQuestion = async (token: string, id: number, text: string) => {
  return await api.patch(`/monou/questions/${id}/`, { text }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 質問の削除
export const deleteMonouQuestion = async (token: string, id: number) => {
  return await api.delete(`/monou/questions/${id}/`, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 公開中のクイズ一覧取得
export const getPublishedMonouQuizzes = async (token: string) => {
  return await api.get('/monou/quizzes/?is_published=true', {
    headers: { Authorization: `JWT ${token}` }
  });
};

// クイズの詳細取得
export const getMonouQuiz = async (token: string, id: number) => {
  return await api.get(`/monou/quizzes/${id}/`, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 回答の送信
export const submitMonouAnswer = async (token: string, quizId: number, choiceId: number) => {
  return await api.post('/monou/answers/', {
    quiz: quizId,
    selected_choice: choiceId
  }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 自分の回答一覧取得
export const getMyMonouAnswers = async (token: string) => {
  return await api.get('/monou/answers/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

// ランキング取得
export const getMonouRanking = async (token: string) => {
  return await api.get('/monou/ranking/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: クイズを公開
export const publishMonouQuiz = async (token: string, quizId: number) => {
  return await api.post(`/monou/publish/${quizId}/`, {}, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: クイズ作成
export const createMonouQuiz = async (token: string, questionId: number, questionText: string, correctAnswer: string, order: number) => {
  return await api.post('/monou/quizzes/', {
    question: questionId,
    question_text: questionText,
    correct_answer: correctAnswer,
    order: order
  }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: 選択肢作成
export const createMonouQuizChoice = async (token: string, quizId: number, choiceText: string, choiceOrder: number, isCorrect: boolean) => {
  return await api.post('/monou/choices/', {
    quiz: quizId,
    choice_text: choiceText,
    choice_order: choiceOrder,
    is_correct: isCorrect
  }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: クイズの更新（順序・公開状態など）
export const updateMonouQuiz = async (token: string, id: number, payload: Partial<{ order: number; is_published: boolean }>) => {
  return await api.patch(`/monou/quizzes/${id}/`, payload, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: クイズの削除
export const deleteMonouQuiz = async (token: string, id: number) => {
  return await api.delete(`/monou/quizzes/${id}/`, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: 全クイズ取得
export const getAllMonouQuizzes = async (token: string) => {
  return await api.get('/monou/quizzes/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: 全質問取得
export const getAllMonouQuestions = async (token: string) => {
  return await api.get('/monou/questions/', {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: 質問を選定
export const selectMonouQuestion = async (token: string, id: number, isSelected: boolean) => {
  return await api.patch(`/monou/questions/${id}/`, { is_selected: isSelected }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: 一括公開/非公開
export const bulkPublishMonouQuizzes = async (token: string, action: 'publish' | 'unpublish') => {
  return await api.post('/monou/bulk-publish/', { action }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// スタッフ用: 結果発表切り替え
export const toggleMonouResultPublish = async (token: string, isPublished: boolean) => {
  return await api.post('/monou/result-publish/', { is_published: isPublished }, {
    headers: { Authorization: `JWT ${token}` }
  });
};

// 結果発表状態を取得
export const getMonouResultPublishStatus = async (token: string) => {
  return await api.get('/monou/result-publish/', {
    headers: { Authorization: `JWT ${token}` }
  });
};
